import React, { Component } from 'react'
import QRcode from './QRcode.svg'


export default class HomeAboutQR extends Component {

    closeFx = () => {
        this.props.closeMe()
    }

    render() {

        return(

            <div className='NightWrapper' onClick={this.closeFx}>
                <img id='HomeQR' src={QRcode} alt='wechat qrcode' style={{position: 'fixed', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)'}} />
            </div>
            	
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/home/HomeAboutQR.js